import * as React from 'react';
import { connect } from 'react-redux';
import notify from '../../shared/feedback/notifications';
import { Button } from 'react-bootstrap';
import { Translate } from '../../shared/LanguageService';
import { handleError } from '../../shared/ErrorCatching';
import * as Actions from './Actions';
import PlanEditorList from './PlanEditorList';
import PlanEditorModal from './PlanEditorModal';

class PlanEditorsPage extends React.Component<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            editId: -1,
            shouldShowModal: false
        };

        this.toggleModal = this.toggleModal.bind(this);
        this.openCreateModal = this.openCreateModal.bind(this);
        this.openEditModal = this.openEditModal.bind(this);
        this.delete = this.delete.bind(this);
    }

    componentDidMount(): void {
        this.props.actions.list().catch((error: any) => handleError(error));
    }

    openCreateModal() {
        this.setState({ editId: -1 });
        this.toggleModal();
    }

    openEditModal(id: number) {
        this.setState({ editId: id });
        this.toggleModal();
    }

    toggleModal() {
        this.setState({ shouldShowModal: !this.state.shouldShowModal });
    }

    delete(id: number): void {
        this.props.actions
            .delete(id)
            .then(() => {
                notify.success(Translate('plan-editors/notification/deleted'));
            })
            .catch((error: any) => handleError(error));
    }

    render() {
        return (
            <div>
                <h1>{Translate('plan-editors/page/header/plan-editors')}</h1>
                <Button
                    bsSize="large"
                    className="pull-right"
                    onClick={this.openCreateModal}
                    bsStyle="success"
                >
                    {Translate('plan-editors/page/button-labels/add')}
                </Button>
                {this.state.shouldShowModal && (
                    <PlanEditorModal
                        editId={this.state.editId}
                        shouldShowModal={this.state.shouldShowModal}
                        closeModal={this.toggleModal}
                    />
                )}
                <PlanEditorList
                    items={this.props.planEditors}
                    delete={this.delete}
                    triggerEdit={this.openEditModal}
                />
            </div>
        );
    }
}

function mapStateToProps(state: any, ownProps: any) {
    return {
        planEditors: state.planEditors.list
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            list: () => dispatch(Actions.list()),
            delete: (id: number) => dispatch(Actions.deletePlanEditor(id))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(PlanEditorsPage);
